import { OnDestroy } from '@angular/core';
import { fuseConfig } from 'app/fuse-config';
import { Subject, BehaviorSubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
import * as i2 from "@angular/common/http";
export class FuseTranslationLoaderService {
    /**
     * Constructor
     *
     * @param {TranslateService} _translateService
     */
    constructor(_translateService, _http) {
        this._translateService = _translateService;
        this._http = _http;
        this.pageTranslationsLoaded = new BehaviorSubject(false);
        this.onLangChanged = new BehaviorSubject(false);
        this._fuseConfig = fuseConfig;
        this._unsubscribeAll = new Subject();
    }
    /**
     * Resolver
     *
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve() {
        return new Promise((resolve, reject) => {
            Promise.all([
                this.getLastLang(),
                this.getLanguages()
            ])
                .then(() => {
                resolve();
            })
                .catch(err => Promise.reject(err))
                .then(() => {
            }, err => {
                // this._router.navigate(['/home']);
            });
        });
    }
    processEmptyTranslations(object) {
        const newObject = {};
        for (const key in object) {
            if (object.hasOwnProperty(key)) {
                if (typeof object[key] === 'object') {
                    newObject[key] = this.processEmptyTranslations(object[key]);
                }
                else if (typeof object[key] === 'string' && object[key] === '') {
                    // do not copy empty strings
                }
                else {
                    newObject[key] = object[key];
                }
            }
        }
        return newObject;
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    /**
     * Load translations
     *
     * @param {Locale} args
     */
    loadTranslations(...args) {
        const locales = [...args];
        locales.forEach((locale) => {
            // use setTranslation() with the third argument set to true
            // to append translations instead of replacing them
            this._translateService.setTranslation(locale.lang, locale.data, true);
        });
    }
    /**
     * get translations
     *
     */
    getTranslations(languageCode, categoryId) {
        return new Promise((resolve, reject) => {
            this._http.get(this._fuseConfig.api.url + '/translator/site/get-by-category/' + languageCode + '/' + categoryId)
                .subscribe(response => {
                this._translateService.setTranslation(languageCode, this.processEmptyTranslations(response['data']), true);
                this.pageTranslationsLoaded.next(true);
                resolve(true);
                setTimeout(() => {
                    this._translateService.use(languageCode);
                }, 1000);
            }, reject);
        });
    }
    getMultipleTranslationCategories(languageCode, categoriesId) {
        const params = {
            categories: categoriesId
        };
        return new Promise((resolve, reject) => {
            this._http.post(this._fuseConfig.api.url + '/translator/site/get-by-categories/' + languageCode, params)
                .subscribe(response => {
                this.pageTranslationsLoaded.next(true);
                resolve(true);
                this._translateService.setTranslation(languageCode, this.processEmptyTranslations(response['data']), true);
                setTimeout(() => {
                    this._translateService.use(languageCode);
                }, 1000);
            }, reject);
        });
    }
    getLastLang() {
        const lang = localStorage.getItem('lang');
        const langName = localStorage.getItem('langName');
        return new Promise((resolve, reject) => {
            this._http.get(this._fuseConfig.api.url + '/translator/site/get-default-language')
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(response => {
                if ((!lang || lang === 'undefined') && (!langName || langName === 'undefined')) {
                    resolve(response['data']);
                }
                else {
                    resolve({ code: lang, name: langName });
                }
            }, reject);
        });
    }
    setLastLang(lang) {
        localStorage.setItem('lang', lang.id);
        localStorage.setItem('langName', lang.title);
        this.onLangChanged.next(true);
    }
    /**
     * get languages
     *
     */
    getLanguages() {
        return new Promise((resolve, reject) => {
            this._http.get(this._fuseConfig.api.url + '/translator/site/get-languages')
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(response => {
                resolve(response['data']);
            }, reject);
        });
    }
    /**
     * Lifecycle hooks
     */
    ngOnDestroy() {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
FuseTranslationLoaderService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FuseTranslationLoaderService_Factory() { return new FuseTranslationLoaderService(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(i2.HttpClient)); }, token: FuseTranslationLoaderService, providedIn: "root" });
